import React from 'react';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as DownArrow } from 'assets/images/down.svg';
import { ReactComponent as DownArrowPurple } from 'assets/images/down-purple.svg';
import styles from './styles.module.scss';

const AutoCompleteDropdown = (props) => {
  const {
    options,
    isMulti,
    placeholder,
    onOptionSelect,
    onSelectAll,
    isFullWidth,
    selectedValue = {},
    bordered,
    handleDropdownOnpen,
    increasedWidth,
    removeDropdown,
    disabled
  } = props;

  const isAllSelected = options.length > 0 && isMulti && selectedValue.length === options.length;

  const handleChange = (values) => {
    if (isMulti && values.find((option) => option.name === 'All')) {
      onSelectAll(!isAllSelected);
    } else {
      onOptionSelect(isMulti ? values : values.value);
    }
  };
  const useStyles = makeStyles(() => ({
    customInput: {
      '& .MuiOutlinedInput-input': {
        cursor: 'pointer'
      },
      '& input': {
        'user-select': 'none',
        '&::selection': {
          'background-color': 'transparent'
        }
      },
      '& .MuiAutocomplete-popupIndicatorOpen': {
        transform: 'none'
      }
    }
  }));
  const classes = useStyles();
  const getOptionSelected = (option, anotherOption) => option.value === anotherOption.value;
  const filter = createFilterOptions();

  return (
    <Autocomplete
      multiple={isMulti}
      classes={{
        root: classNames({
          [styles.borderRoot]: bordered,
          [styles.root]: !bordered,
          [styles.disabled]: disabled,
          '': !disabled
        }),
        inputRoot: classNames({
          [styles.borderInputRoot]: bordered,
          [styles.inputRoot]: !bordered
        }),
        paper: styles.paper,
        listbox: styles.listBox,
        tag: styles.tag,
        input: classNames({
          [styles.increasedInputWidth]: increasedWidth,
          [styles.inputField]: !increasedWidth,
          [styles.dropdownItem]: removeDropdown
        }),
        popupIndicator: styles.popupIndicator,
        endAdornment: removeDropdown && styles.dropdownItem
      }}
      fullWidth={isFullWidth}
      id='autocomplete-tags'
      options={options}
      disableCloseOnSelect={isMulti}
      getOptionLabel={(option) => option.name}
      value={selectedValue}
      getOptionSelected={getOptionSelected}
      onChange={(e, data) => handleChange(data)}
      filterOptions={(optionsList, params) => {
        const filtered = filter(optionsList, params);
        return isMulti ? [{ name: 'All', value: 'All' }, ...filtered] : filtered;
      }}
      popupIcon={bordered ? <DownArrowPurple data-testid='down-arrow-purple' /> : <DownArrow />}
      renderOption={(option) => <span>{option.name}</span>}
      renderInput={(params) => (
        <TextField
          className={classes.customInput}
          {...params}
          variant='outlined'
          placeholder={!selectedValue?.length ? placeholder : ''}
          InputProps={{
            ...params.InputProps,
            classes: {
              notchedOutline: styles.noBorder
            },
            readOnly: true
          }}
        />
      )}
      renderTags={(value) => (
        <span style={{ paddingLeft: '0.5rem' }}>
          {value[0].name + (value.length > 1 ? ` & ${value.length - 1} More` : '')}
        </span>
      )}
      noOptionsText='No options'
      disableClearable
      onOpen={handleDropdownOnpen}
      disabled={disabled}
    />
  );
};

AutoCompleteDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isMulti: PropTypes.bool,
  placeholder: PropTypes.string,
  selectedValue: PropTypes.oneOfType([
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    PropTypes.array
  ]).isRequired,
  onOptionSelect: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func,
  isFullWidth: PropTypes.bool,
  bordered: PropTypes.bool,
  handleDropdownOnpen: PropTypes.func,
  increasedWidth: PropTypes.bool,
  removeDropdown: PropTypes.bool,
  disabled: PropTypes.bool
};

AutoCompleteDropdown.defaultProps = {
  isMulti: false,
  placeholder: '',
  onSelectAll: () => null,
  handleDropdownOnpen: () => null,
  removeDropdown: false,
  isFullWidth: false,
  bordered: false,
  increasedWidth: false,
  disabled: false
};

export default AutoCompleteDropdown;
